import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {WB_NoteUserRow, WB_NoteRow, WB_UserRow} from "../PA.Core/PAdbSchemaRows";
import {IwbNote} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Note, esWB_Note_User, esWB_User
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


export class NoteBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Note: WB_NoteRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Note'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Note = undefined;
    }

    get WB_Note(): WB_NoteRow
    {
        return this.drWB_Note;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Note");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == undefined) {
                var sError = "Unable to determine dbContext for new Note.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Note)
                .then((newNoteRow: WB_NoteRow)=> {
                    newNoteRow.setDefaults()
                    self.drWB_Note = newNoteRow;
                    self.dbContext.add(esWB_Note, newNoteRow)
                    self.Identity.setAll(self.WB_Note.cif.WB_NOTE_ID,self.WB_Note.cif.WB_NOTE_ID,self.WB_Note.cif.NOTE_TITLE);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Note, 'WB_NOTE_ID', 'WB_NOTE_ID', 'NOTE_TITLE')

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Note (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "Note already loaded.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == undefined) {
                var sError = "Unable to determine dbContext for new Domain.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            this.dbContext.find(esWB_Note,  anId)
                .then((aNoteRow) => {

                    if(_.isEmpty(aNoteRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Note = aNoteRow;
                    self.Identity.setAll(self.WB_Note.cif.WB_NOTE_ID,self.WB_Note.cif.WB_NOTE_ID,self.WB_Note.cif.NOTE_TITLE);
                    self.Identity.listenToRecordUpdates(self.WB_Note, 'WB_NOTE_ID', 'WB_NOTE_ID', 'NOTE_TITLE')
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                    // TODO, add in additional child relationships.
                    return (self.drWB_Note.loadRelations([esWB_Note_User],
                        self.LoadOptions));
                })
                .then((aNoteRow: WB_NoteRow) => {
                    var nextTasks: Promise<any>[] = []
                    _.forEach(aNoteRow.WB_NoteUserRows, (aRow: WB_NoteUserRow) => {
                        nextTasks.push( aRow.loadRelations([esWB_User]))
                    });
                    return Promise.all(nextTasks)
                })
                .then((aDomainRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Note.cif.WB_NOTE_ID);
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Note.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbDomain = <IwbNote>self.drWB_Note;
        this.SaveProgressProvider.start("Saving " + wbDomain.WB_NOTE_ID );

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Note.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            saveFunction(esWB_Note, self.drWB_Note,{})
                .then((ignored) => {
                    var tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Note_User, self.drWB_Note.WB_NoteUserRows))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get  bIsSaved(): boolean {
        return this._bIsSaved;
    }

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbDomain = <IwbNote>self.drWB_Note;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbDomain.WB_NOTE_ID );
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Domain

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Note.markDeleted()

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

  //<editor-fold desc = "Additional operations">

  addNoteUser(aUserId: number): Promise<IBusinessObject> {

    var self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      // first find out if record exists.
      let found = false

      _.forEach(self.drWB_Note.WB_NoteUserRows, (aNoteUserRow: WB_NoteUserRow) => {
        if (aNoteUserRow.isActive && aNoteUserRow.cif.WB_AUTHUSR_ID == aUserId) {
          found = true
          return false;
        }
      });


      if (found) {
        resolve(self)
        return;
      } // exists..

      let aUserRow: WB_UserRow = undefined

      self.dbContext.find(esWB_User, aUserId)
        .then((aRecord: WB_UserRow) => {

          if (_.isEmpty(aRecord)) {
            // Bad User Id...
            resolve(self)
            return
          }

          aUserRow = aRecord

          // create new records
          return self.dbContext.createRecordWithKey(esWB_Note_User)

        }).then((aNoteUserRow: WB_NoteUserRow) => {

          aNoteUserRow.setDefaults()
          aNoteUserRow.cif.WB_NOTE_ID = self.drWB_Note.cif.WB_NOTE_ID
          aNoteUserRow.cif.WB_AUTHUSR_ID = aUserId
          aNoteUserRow.WB_UserRow = aUserRow
          self.dbContext.add(esWB_Note_User, aNoteUserRow)
          resolve(self)
        }).catch((err) => {
          error(err)
        })
    })
  }

  removeNoteUser(aNoteUserId: number): Promise<IBusinessObject> {
      var self = this

      return new Promise<IBusinessObject>((resolve, error) => {

          _.forEach(self.drWB_Note.WB_NoteUserRows, (aNoteUserRelRow: WB_NoteUserRow) => {
              if (aNoteUserRelRow.isActive && aNoteUserRelRow.cif.WB_NOTEUSRR_ID == aNoteUserId) {
                  aNoteUserRelRow.markDeleted()
              }
          })

          resolve(self)
      })
  }
  //</editor-fold>
};
PAEnvironment.registerBusinessObjectClass( NoteBO , "NoteBO", "Note")